module.exports = __webpack_public_path__ + "static/toolkit_website_banner-9c784cfcde4cf94aa0760848c1fbe2ad.png";